var map = {
	"./": [
		64468
	],
	"./animation-6a0c5338": [
		25450
	],
	"./animation-6a0c5338.js": [
		25450
	],
	"./app-globals-ffe436be": [
		48197,
		8197
	],
	"./app-globals-ffe436be.js": [
		48197,
		8197
	],
	"./button-active-365a5048": [
		48478,
		8478
	],
	"./button-active-365a5048.js": [
		48478,
		8478
	],
	"./capacitor-59395cbd": [
		55130,
		5130
	],
	"./capacitor-59395cbd.js": [
		55130,
		5130
	],
	"./compare-with-utils-a96ff2ea": [
		6654,
		6654
	],
	"./compare-with-utils-a96ff2ea.js": [
		6654,
		6654
	],
	"./config-49c88215": [
		61076
	],
	"./config-49c88215.js": [
		61076
	],
	"./cubic-bezier-fe2083dc": [
		97183
	],
	"./cubic-bezier-fe2083dc.js": [
		97183
	],
	"./data-bb424ba8": [
		48842,
		8842
	],
	"./data-bb424ba8.js": [
		48842,
		8842
	],
	"./dir-babeabeb": [
		15441,
		5441
	],
	"./dir-babeabeb.js": [
		15441,
		5441
	],
	"./focus-visible-dd40d69f": [
		12186,
		2186
	],
	"./focus-visible-dd40d69f.js": [
		12186,
		2186
	],
	"./form-controller-21dd62b1": [
		4214,
		4214
	],
	"./form-controller-21dd62b1.js": [
		4214,
		4214
	],
	"./framework-delegate-ed4ba327": [
		11265
	],
	"./framework-delegate-ed4ba327.js": [
		11265
	],
	"./gesture-controller-1bf57181": [
		2315
	],
	"./gesture-controller-1bf57181.js": [
		2315
	],
	"./haptic-554688a5": [
		80263,
		263
	],
	"./haptic-554688a5.js": [
		80263,
		263
	],
	"./hardware-back-button-65a9e284": [
		5947
	],
	"./hardware-back-button-65a9e284.js": [
		5947
	],
	"./helpers-be245865": [
		94919
	],
	"./helpers-be245865.js": [
		94919
	],
	"./index": [
		64468
	],
	"./index-020f5464": [
		33400,
		3400
	],
	"./index-020f5464.js": [
		33400,
		3400
	],
	"./index-2cf77112": [
		56116
	],
	"./index-2cf77112.js": [
		56116
	],
	"./index-4feaf001": [
		27093
	],
	"./index-4feaf001.js": [
		27093
	],
	"./index-73fa3fe8": [
		79748
	],
	"./index-73fa3fe8.js": [
		79748
	],
	"./index-7ab328b6": [
		27987
	],
	"./index-7ab328b6.js": [
		27987
	],
	"./index-9b0d46f4": [
		79697
	],
	"./index-9b0d46f4.js": [
		79697
	],
	"./index-a5d50daf": [
		35900
	],
	"./index-a5d50daf.js": [
		35900
	],
	"./index-f3946ac1": [
		36188,
		6188
	],
	"./index-f3946ac1.js": [
		36188,
		6188
	],
	"./index-f7dc70ba": [
		2783,
		2783
	],
	"./index-f7dc70ba.js": [
		2783,
		2783
	],
	"./index.js": [
		64468
	],
	"./input-shims-5329bbe8": [
		58130,
		8130
	],
	"./input-shims-5329bbe8.js": [
		58130,
		8130
	],
	"./input.utils-a445f677": [
		83581,
		3581
	],
	"./input.utils-a445f677.js": [
		83581,
		3581
	],
	"./ion-accordion_2.entry": [
		79,
		79
	],
	"./ion-accordion_2.entry.js": [
		79,
		79
	],
	"./ion-action-sheet.entry": [
		3552,
		3552
	],
	"./ion-action-sheet.entry.js": [
		3552,
		3552
	],
	"./ion-alert.entry": [
		38514,
		8514
	],
	"./ion-alert.entry.js": [
		38514,
		8514
	],
	"./ion-app_8.entry": [
		73751,
		3751
	],
	"./ion-app_8.entry.js": [
		73751,
		3751
	],
	"./ion-avatar_3.entry": [
		65336,
		5336
	],
	"./ion-avatar_3.entry.js": [
		65336,
		5336
	],
	"./ion-back-button.entry": [
		27273,
		7273
	],
	"./ion-back-button.entry.js": [
		27273,
		7273
	],
	"./ion-backdrop.entry": [
		31685,
		1685
	],
	"./ion-backdrop.entry.js": [
		31685,
		1685
	],
	"./ion-breadcrumb_2.entry": [
		63434,
		3434
	],
	"./ion-breadcrumb_2.entry.js": [
		63434,
		3434
	],
	"./ion-button_2.entry": [
		24313,
		4313
	],
	"./ion-button_2.entry.js": [
		24313,
		4313
	],
	"./ion-card_5.entry": [
		30736,
		736
	],
	"./ion-card_5.entry.js": [
		30736,
		736
	],
	"./ion-checkbox.entry": [
		49229,
		9229
	],
	"./ion-checkbox.entry.js": [
		49229,
		9229
	],
	"./ion-chip.entry": [
		70840,
		840
	],
	"./ion-chip.entry.js": [
		70840,
		840
	],
	"./ion-col_3.entry": [
		34898,
		4898
	],
	"./ion-col_3.entry.js": [
		34898,
		4898
	],
	"./ion-datetime-button.entry": [
		50761,
		8842,
		6801
	],
	"./ion-datetime-button.entry.js": [
		50761,
		8842,
		6801
	],
	"./ion-datetime_3.entry": [
		79141,
		8842,
		9141
	],
	"./ion-datetime_3.entry.js": [
		79141,
		8842,
		9141
	],
	"./ion-fab_3.entry": [
		35075,
		5075
	],
	"./ion-fab_3.entry.js": [
		35075,
		5075
	],
	"./ion-img.entry": [
		90405,
		405
	],
	"./ion-img.entry.js": [
		90405,
		405
	],
	"./ion-infinite-scroll_2.entry": [
		84125,
		4125
	],
	"./ion-infinite-scroll_2.entry.js": [
		84125,
		4125
	],
	"./ion-input.entry": [
		91823,
		1823
	],
	"./ion-input.entry.js": [
		91823,
		1823
	],
	"./ion-item-option_3.entry": [
		94544,
		4544
	],
	"./ion-item-option_3.entry.js": [
		94544,
		4544
	],
	"./ion-item_8.entry": [
		28926,
		8926
	],
	"./ion-item_8.entry.js": [
		28926,
		8926
	],
	"./ion-loading.entry": [
		99112,
		9112
	],
	"./ion-loading.entry.js": [
		99112,
		9112
	],
	"./ion-menu_3.entry": [
		65795,
		5795
	],
	"./ion-menu_3.entry.js": [
		65795,
		5795
	],
	"./ion-modal.entry": [
		78208,
		8208
	],
	"./ion-modal.entry.js": [
		78208,
		8208
	],
	"./ion-nav_2.entry": [
		87282,
		7282
	],
	"./ion-nav_2.entry.js": [
		87282,
		7282
	],
	"./ion-picker-column-internal.entry": [
		71733,
		1733
	],
	"./ion-picker-column-internal.entry.js": [
		71733,
		1733
	],
	"./ion-picker-internal.entry": [
		60836,
		836
	],
	"./ion-picker-internal.entry.js": [
		60836,
		836
	],
	"./ion-popover.entry": [
		49414,
		9414
	],
	"./ion-popover.entry.js": [
		49414,
		9414
	],
	"./ion-progress-bar.entry": [
		54468,
		4468
	],
	"./ion-progress-bar.entry.js": [
		54468,
		4468
	],
	"./ion-radio_2.entry": [
		84579,
		4579
	],
	"./ion-radio_2.entry.js": [
		84579,
		4579
	],
	"./ion-range.entry": [
		53507,
		3507
	],
	"./ion-range.entry.js": [
		53507,
		3507
	],
	"./ion-refresher_2.entry": [
		38067,
		8067
	],
	"./ion-refresher_2.entry.js": [
		38067,
		8067
	],
	"./ion-reorder_2.entry": [
		21038,
		1038
	],
	"./ion-reorder_2.entry.js": [
		21038,
		1038
	],
	"./ion-ripple-effect.entry": [
		52974,
		2974
	],
	"./ion-ripple-effect.entry.js": [
		52974,
		2974
	],
	"./ion-route_4.entry": [
		50534,
		534
	],
	"./ion-route_4.entry.js": [
		50534,
		534
	],
	"./ion-searchbar.entry": [
		49879,
		9879
	],
	"./ion-searchbar.entry.js": [
		49879,
		9879
	],
	"./ion-segment_2.entry": [
		97185,
		7185
	],
	"./ion-segment_2.entry.js": [
		97185,
		7185
	],
	"./ion-select_3.entry": [
		16414,
		6414
	],
	"./ion-select_3.entry.js": [
		16414,
		6414
	],
	"./ion-spinner.entry": [
		67654,
		7654
	],
	"./ion-spinner.entry.js": [
		67654,
		7654
	],
	"./ion-split-pane.entry": [
		90158,
		158
	],
	"./ion-split-pane.entry.js": [
		90158,
		158
	],
	"./ion-tab-bar_2.entry": [
		52566,
		2566
	],
	"./ion-tab-bar_2.entry.js": [
		52566,
		2566
	],
	"./ion-tab_2.entry": [
		23478,
		3478
	],
	"./ion-tab_2.entry.js": [
		23478,
		3478
	],
	"./ion-text.entry": [
		97335,
		7335
	],
	"./ion-text.entry.js": [
		97335,
		7335
	],
	"./ion-textarea.entry": [
		1157,
		1157
	],
	"./ion-textarea.entry.js": [
		1157,
		1157
	],
	"./ion-toast.entry": [
		51126,
		1126
	],
	"./ion-toast.entry.js": [
		51126,
		1126
	],
	"./ion-toggle.entry": [
		14790,
		4790
	],
	"./ion-toggle.entry.js": [
		14790,
		4790
	],
	"./ionic": [
		23450,
		3450
	],
	"./ionic-global-d89a6ff6": [
		95224
	],
	"./ionic-global-d89a6ff6.js": [
		95224
	],
	"./ionic.js": [
		23450,
		3450
	],
	"./ios.transition-1e29344b": [
		87929
	],
	"./ios.transition-1e29344b.js": [
		87929
	],
	"./keyboard-52278bd7": [
		29079,
		5939
	],
	"./keyboard-52278bd7.js": [
		29079,
		5939
	],
	"./keyboard-73175e24": [
		94353,
		4353
	],
	"./keyboard-73175e24.js": [
		94353,
		4353
	],
	"./keyboard-controller-ec5c2bfa": [
		69934,
		9934
	],
	"./keyboard-controller-ec5c2bfa.js": [
		69934,
		9934
	],
	"./loader": [
		25140,
		5140
	],
	"./loader.js": [
		25140,
		5140
	],
	"./lock-controller-316928be": [
		62006,
		2006
	],
	"./lock-controller-316928be.js": [
		62006,
		2006
	],
	"./md.transition-b2a9590f": [
		75397
	],
	"./md.transition-b2a9590f.js": [
		75397
	],
	"./notch-controller-6bd3e0f9": [
		9333,
		9333
	],
	"./notch-controller-6bd3e0f9.js": [
		9333,
		9333
	],
	"./overlays-ad4b0449": [
		34637
	],
	"./overlays-ad4b0449.js": [
		34637
	],
	"./spinner-configs-964f7cf3": [
		45199,
		5199
	],
	"./spinner-configs-964f7cf3.js": [
		45199,
		5199
	],
	"./status-tap-0575d437": [
		27760,
		4943
	],
	"./status-tap-0575d437.js": [
		27760,
		4943
	],
	"./swipe-back-37a22d34": [
		22559,
		2559
	],
	"./swipe-back-37a22d34.js": [
		22559,
		2559
	],
	"./theme-01f3f29c": [
		67631
	],
	"./theme-01f3f29c.js": [
		67631
	],
	"./watch-options-c2911ace": [
		28280,
		8280
	],
	"./watch-options-c2911ace.js": [
		28280,
		8280
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 63443;
module.exports = webpackAsyncContext;